import { Navigate, useParams } from 'react-router-dom';

import { DrugFamilyHeaderV2 } from '../../components/common/DrugFamilyHeaderV2';
import { PrescriptionOverview } from '../../components/transfer-flow/PrescriptionOverview';
import { getFragment, getFragments } from '../../graphql';
import { GetProviderOffersDocument } from '../../graphql/generated/graphql';
import { QueryLoader } from '../../loaders';
import { getAbsoluteRoute } from '../../util';

export const TransferRouteV2 = () => {
    const { providerOffersId, offerId } = useParams();

    const Loader = QueryLoader<typeof GetProviderOffersDocument>;

    if (!providerOffersId || !offerId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    return (
        <Loader
            query={GetProviderOffersDocument}
            variables={{ id: providerOffersId }}
            render={(data) => {
                const providerOffers = getFragment(data.providerOffers);
                const offers = getFragments(providerOffers?.offers);
                const selectedOffer = offers?.find(
                    (offer) => offer.id === offerId
                );

                const medication =
                    selectedOffer && getFragment(selectedOffer.medication);

                const controlledSubstanceCode = getFragment(
                    providerOffers?.medication
                )?.controlledSubstanceCode;

                if (medication) {
                    return (
                        <PrescriptionOverview
                            header={
                                <DrugFamilyHeaderV2
                                    controlledSubstanceCode={
                                        controlledSubstanceCode
                                    }
                                    medication={medication}
                                />
                            }
                            offer={selectedOffer}
                            providerOffersId={providerOffersId}
                            controlledSubstanceCode={controlledSubstanceCode}
                        />
                    );
                }

                return <Navigate to={getAbsoluteRoute('error')} />;
            }}
        />
    );
};
